import { iconPropColor } from "../../types/IconComponent";
var getColorVariable = function getColorVariable(color) {
  if (color === 'white') {
    return '--color-constant-02';
  }
  if (color === 'black') {
    return '--color-constant-01';
  }
  return "--color-icon-".concat(color);
};
export var getColor = function getColor(color) {
  if (iconPropColor.includes(color)) {
    return "var(".concat(getColorVariable(color), ")");
  }
  return color;
};